// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".participants-block[data-v-2b26d9be] {\n  margin-bottom: 24px;\n}\n.participants-grid[data-v-2b26d9be] {\n  display: grid;\n  grid-template-columns: 160px auto;\n  gap: 16px;\n}\n.segment-people[data-v-2b26d9be] {\n  margin-bottom: 13px;\n}\n.sum-line[data-v-2b26d9be] {\n  margin-top: 14px;\n  margin-bottom: 12px;\n}\n.segment-label[data-v-2b26d9be] {\n  display: flex;\n  align-items: center;\n}\n", ""]);
// Exports
module.exports = exports;
